var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgGroupedBarChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 91,
    viewBox: "0 0 183 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.97484,
    height: 91,
    fill: "#78A9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1257,
    y: 60.8897,
    width: 9.97484,
    height: 30.1103,
    fill: "#DA1E28"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.761,
    y: 53.5294,
    width: 22.2516,
    height: 37.4706,
    fill: "#A7F0BA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 117.013,
    y: 53.5294,
    width: 22.2516,
    height: 37.4706,
    fill: "#DA1E28"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.2767,
    y: 70.9265,
    width: 21.8679,
    height: 20.0735,
    fill: "#24A148"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 161.132,
    y: 80.2941,
    width: 21.8679,
    height: 10.7059,
    fill: "#DA1E28"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgGroupedBarChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grouped-bar-chart.548e3bfd1fda94628d9909d180ae2304.svg";